import { Button } from "@/components/ui/button";
import { Share2 } from "lucide-react";

export default function ShareSection() {
  const shareMessage = encodeURIComponent(
    `🔥 ଶିକ୍ଷକ ବନ୍ଧୁ, ଏଇ App ଟା Download କରନ୍ତୁ — School କାମ ଆଉ ମୁଣ୍ଡ ବିନ୍ଧାନାହିଁ!\n\n` +
    `✅ MDM Calculation — 2 ସେକେଣ୍ଡ ରେ!\n` +
    `✅ Admission Eligibility — ଗୋଟିଏ Click ରେ!\n` +
    `✅ Marks, Salary, Application — ସବୁ ଗୋଟିଏ App ରେ!\n\n` +
    `📱 1000+ ଶିକ୍ଷକ ବ୍ୟବହାର କରୁଛନ୍ତି — ଆପଣ ଛାଡି ଦେବେ?\n\n` +
    `👉 ଏଠାରୁ Download କରନ୍ତୁ: https://play.google.com/store/apps/details?id=com.wnapp.id1781430851106&hl=en_IN\n\n` +
    `⚡ ମାତ୍ର ₹199/ବର୍ଷ ରେ Premium — ₹4/ସପ୍ତାହ ରୁ କମ୍!\n` +
    `🎁 Registration FREE — ଆଜି ହିଁ Start କରନ୍ତୁ!`
  );

  const whatsappShareLink = `https://wa.me/?text=${shareMessage}`;

  return (
    <section data-testid="share-section" className="py-10 md:py-14 bg-green-700 relative overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <div className="absolute -top-10 -left-10 w-40 h-40 bg-white rounded-full" />
        <div className="absolute -bottom-10 -right-10 w-56 h-56 bg-white rounded-full" />
      </div>
      <div className="relative container mx-auto px-4 md:px-6 max-w-5xl text-center">
        <p className="text-green-100 text-sm font-medium uppercase tracking-wide mb-2">
          ଆପଣଙ୍କ ଶିକ୍ଷକ ବନ୍ଧୁଙ୍କୁ ଜଣାନ୍ତୁ
        </p>
        <h2
          data-testid="share-headline"
          className="text-2xl md:text-3xl font-bold text-white leading-snug"
          style={{ fontFamily: "'Outfit', sans-serif" }}
        >
          ଏଇ App ର ଖବର ଆପଣଙ୍କ WhatsApp Group ରେ Share କରନ୍ତୁ!
        </h2>
        <p className="mt-3 text-green-100 text-sm md:text-base max-w-lg mx-auto">
          ଆପଣଙ୍କ ସାଥୀ ଶିକ୍ଷକମାନେ ମଧ୍ୟ ଏହି App ବ୍ୟବହାର କରି ସମୟ ବଞ୍ଚାଇ ପାରିବେ। ଗୋଟିଏ Share ରେ ସେମାନଙ୍କ କାମ ସହଜ ହୋଇଯିବ!
        </p>
        <Button
          data-testid="whatsapp-share-btn"
          asChild
          className="mt-6 h-14 px-10 bg-[#25D366] hover:bg-[#1ebe5d] text-white rounded-full text-base md:text-lg font-bold shadow-xl shadow-black/20"
        >
          <a href={whatsappShareLink} target="_blank" rel="noopener noreferrer">
            <Share2 className="mr-2 w-5 h-5" />
            WhatsApp ରେ Share କରନ୍ତୁ
          </a>
        </Button>
        <p className="mt-3 text-green-200 text-xs">
          ଗୋଟିଏ Click ରେ ଆପଣଙ୍କ Teacher Group ରେ Message ଯିବ
        </p>
      </div>
    </section>
  );
}
